import { render, staticRenderFns } from "./CampaingEmailList.vue?vue&type=template&id=6c2b0467&scoped=true"
import script from "./CampaingEmailList.vue?vue&type=script&lang=js"
export * from "./CampaingEmailList.vue?vue&type=script&lang=js"
import style0 from "./CampaingEmailList.vue?vue&type=style&index=0&id=6c2b0467&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b0467",
  null
  
)

export default component.exports